module.exports = {
    nullTips: 'User name and password can not be null.',
    userName: 'User Name',
    password: 'Password',
    login: 'Login',
    veriCode: 'Captcha',
    inputCodeTips: 'Please input verification code.',
    clickToRefresh: 'Click to refresh',
    INVALID_VERI_CODE: 'Verification code is invalid.',
    INVALID_USER_OR_PWD: 'Invalid user or password.'
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/i18n/locale.en.js
// module id = 4
// module chunks = 0